(() => {
  const clamp = (value, min = 0, max = 1) => Math.min(max, Math.max(min, value));

  const initProgressiveInlineText = (root) => {
    if (!root || root.dataset.progressiveInlineReady === 'true') return;

    const tokens = Array.from(root.querySelectorAll('[data-progressive-token]'));
    if (!tokens.length) return;

    root.dataset.progressiveInlineReady = 'true';

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let ticking = false;

    const setComplete = () => {
      tokens.forEach((token) => {
        token.style.opacity = '1';
        if (token.matches('[data-progressive-media]')) token.style.transform = 'none';
      });
    };

    const update = () => {
      ticking = false;

      if (reducedMotion.matches) {
        setComplete();
        return;
      }

      const rect = root.getBoundingClientRect();
      const scrollable = Math.max(1, rect.height - window.innerHeight);
      const progress = clamp(-rect.top / scrollable);
      const tokenCount = Math.max(1, tokens.length - 1);
      const inactiveOpacity = parseFloat(root.dataset.inactiveOpacity || '0.16');
      const revealSpan = 0.2;
      const sequenceEnd = 0.88;

      tokens.forEach((token, index) => {
        const start = (index / tokenCount) * sequenceEnd;
        const local = clamp((progress - start) / revealSpan);
        const opacity = inactiveOpacity + (1 - inactiveOpacity) * local;

        token.style.opacity = opacity.toFixed(3);

        if (token.matches('[data-progressive-media]')) {
          const scale = 0.74 + 0.26 * local;
          const translate = 0.06 * (1 - local);
          token.style.transform = `translateY(${translate.toFixed(3)}em) scale(${scale.toFixed(3)})`;
        }
      });
    };

    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    };

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);

    if (typeof reducedMotion.addEventListener === 'function') {
      reducedMotion.addEventListener('change', requestUpdate);
    }

    update();
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-progressive-inline-text]').forEach(initProgressiveInlineText);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
